import { render, staticRenderFns } from "./GenericLoading.vue?vue&type=template&id=0221f7b6&scoped=true&"
import script from "./GenericLoading.vue?vue&type=script&lang=js&"
export * from "./GenericLoading.vue?vue&type=script&lang=js&"
import style0 from "./GenericLoading.vue?vue&type=style&index=0&id=0221f7b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0221f7b6",
  null
  
)

export default component.exports